import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import { CorpComponent} from './corp.component';
import { SideBarComponent } from '../shared/side-bar/side-bar.component';
import { HomeComponent } from './home/home.component';
import { HeaderModule } from '../shared/header/header.module';


@NgModule({
  imports: [CommonModule, RouterModule, FormsModule],
  declarations: [CorpComponent,HomeComponent ],
  exports: [CorpComponent]
})

export class CorpModule {}



// WEBPACK FOOTER //
// ./src/app/corp/corp.module.ts